import React, { useState } from 'react';
import { Typography } from '@mui/material';
import { Dayjs } from 'dayjs';
import { CustomTimeSelector } from '../../../common';
import { useGeneralSettings } from '../../../../hooks';
import './TimeSelectorItem.scss';

interface TimeSelectorItemProps {
  label: string;
  value: Dayjs | null;
  onChange: (value: Dayjs | null) => void;
  disabled?: boolean;
  className?: string;
}

export const TimeSelectorItem: React.FC<TimeSelectorItemProps> = ({
  label,
  value,
  onChange,
  disabled = false,
  className = '',
}) => {
  const {
    generalSettings: { timeFormat },
  } = useGeneralSettings();
  const [open, setOpen] = useState(false);

  return (
    <div className={`time-selector-item ${className}`}>
      <Typography className="time-selector-item__label">{label}</Typography>
      <div className="time-selector-item__selector-wrapper">
        <CustomTimeSelector
          value={value}
          onChange={onChange}
          amPm={timeFormat === '12h'}
          fontWeight="bold"
          open={open}
          setOpen={setOpen}
          disabled={disabled}
          className="time-selector-item__selector"
          autocompleteClassName="time-selector-item__autocomplete"
          paperClassName="time-selector-item__paper"
        />
      </div>
    </div>
  );
};
